import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class LogServices {
  constructor(private apollo: Apollo) {
  }

  getLog(filtros: any, fecha1:string, fecha2:string) {
    return this.apollo.query({
      query: gql`
        query getLog($filtros:String, $fecha1:String, $fecha2:String){
          getLog(filtros:$filtros, fecha1:$fecha1, fecha2:$fecha2){
            tipo
            fecha
            usuario
            descripcion
            entidad
            idEntidad
          }
        }
      `,
      variables: {
        filtros: JSON.stringify(filtros),
        fecha1: fecha1,
        fecha2:fecha2
      }
    });
  }
}
